import { useCheckoutFlow } from "~components/pages/listing/checkout/checkout-flow/checkout-flow-provider"
import useDraftQuote from "~utils/use-draft-quote"

import useCreateQuote from "./use-create-quote"

export type OnCreateOrCompletedFunc = (args: {
    listingId?: string
    quoteId: string
}) => void

export default function useCheckoutFlowDraftQuote({
    listingId,
    onCreateQuoteCompleted,
}: {
    listingId?: string
    onCreateQuoteCompleted?: OnCreateOrCompletedFunc
} = {}) {
    const { draftQuoteArgs, createQuoteArgs } =
        useDraftQuoteAndCreateQuoteArgs()

    const {
        draftQuote,
        isLoading: isLoadingDraftQuote,
        error: draftQuoteError,
        isTripValid,
    } = useDraftQuote(draftQuoteArgs)
    const { createQuote, isLoading: isLoadingCreateQuote } = useCreateQuote({
        quoteArgs: createQuoteArgs,
        onCompleted: (quoteId) =>
            onCreateQuoteCompleted?.({ quoteId, listingId }),
    })

    return {
        draftQuote,
        createQuote,
        isLoadingDraftQuote,
        isLoadingCreateQuote,
        draftQuoteError,
        isTripValid,
    }
}

function useDraftQuoteAndCreateQuoteArgs() {
    const { dates, packageState, bookingInvitePackageInfo, listing } =
        useCheckoutFlow()

    const listingId = listing?.id

    const sharedArgs = {
        dates,
        coupon: bookingInvitePackageInfo?.coupon?.id,
        bookingInviteId: bookingInvitePackageInfo?.id,
        listingId,
    }
    const quotePackage = {
        pricing_package_id: packageState.pricing_package_id ?? "",
        number_of_guests: packageState.number_of_guests,
        add_ons: packageState.add_ons ?? [],
    }

    const draftQuoteArgs = {
        ...sharedArgs,
        pricingPackageId: quotePackage.pricing_package_id,
        addOns: quotePackage.add_ons,
        totalGuests: quotePackage.number_of_guests,
    }
    const createQuoteArgs = { ...sharedArgs, packages: [quotePackage] }

    return { draftQuoteArgs, createQuoteArgs, listingId }
}
